// import fanduelLogo from '@/assets/bookmakers/fanduel_blue.png'
import fanduelLogo from '@/assets/bookmakers/fanduel_blue.png'
import draftkings from '@/assets/bookmakers/draftkings.svg'
import espn from '@/assets/bookmakers/espn.svg'
import kalshi from '@/assets/bookmakers/kalshi.svg'
import betmgm from '@/assets/bookmakers/bet_mgm.svg'
import betonline from '@/assets/bookmakers/betonline.png'
import caesars from '@/assets/bookmakers/caesars.png'
import lowvig from '@/assets/bookmakers/lowvig.jpg'
import novig from '@/assets/bookmakers/novig.png'
import pinnacle from '@/assets/bookmakers/pinnacle.png'
import polymarket from '@/assets/bookmakers/polymarket.svg'
import prophetx from '@/assets/bookmakers/prophetx.png'

export const bookmakerLogos = {
  draftkings: draftkings,
  fanduel: fanduelLogo,
  betmgm: betmgm,
  espn: espn,
  espnbet: espn,
  kalshi: kalshi,
  betonlineag: betonline,
  lowvig: lowvig,
  novig: novig,
  pinnacle: pinnacle,
  polymarket: polymarket,
  prophetx: prophetx,
  williamhill_us: caesars,
};
